exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-card__header[data-v-550195ba]{padding:20px;border-bottom:1px solid #ebeef5;-webkit-box-sizing:border-box;box-sizing:border-box;background:#f3f3fb}.card_title[data-v-550195ba]{text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-550195ba","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sentiment/index.vue
// module id = 6
// module chunks = 0